export const AttachmentTypeEnumText =
{
    File: "File",
    Link: "Link"
}